import { render, staticRenderFns } from "./KnStudentResultsViewerModal.vue?vue&type=template&id=82a1709c"
import script from "./KnStudentResultsViewerModal.js?vue&type=script&lang=js&external"
export * from "./KnStudentResultsViewerModal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports